import type { FC } from "react";
import { twMerge } from "tailwind-merge";

interface HorizontalDividerProps {
  className?: string;
  hideIfLast?: boolean;
}

export const HorizontalDivider: FC<HorizontalDividerProps> = ({ className, hideIfLast }) => {
  return (
    <div
      className={twMerge("border-t border-black-tint-90", className, hideIfLast && "last:hidden")}
    />
  );
};
